import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import Questionnaire1Screen from '~/pages/homes/weight-loss/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/weight-loss/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/weight-loss/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/weight-loss/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/weight-loss/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/weight-loss/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/weight-loss/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/weight-loss/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/weight-loss/Questionnaire9Screen';
import Questionnaire9BScreen from '~/pages/homes/weight-loss/Questionnaire9BScreen';
import Questionnaire10Screen from '~/pages/homes/weight-loss/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/homes/weight-loss/Questionnaire11Screen';
import Questionnaire12Screen from '~/pages/homes/weight-loss/Questionnaire12Screen';
import Questionnaire13Screen from '~/pages/homes/weight-loss/Questionnaire13Screen';
import Questionnaire14Screen from '~/pages/homes/weight-loss/Questionnaire14Screen';
import Questionnaire15Screen from '~/pages/homes/weight-loss/Questionnaire15Screen';
import Questionnaire16Screen from '~/pages/homes/weight-loss/Questionnaire16Screen';
import Questionnaire17Screen from '~/pages/homes/weight-loss/Questionnaire17Screen';
import Questionnaire18Screen from '~/pages/homes/weight-loss/Questionnaire18Screen';
import Questionnaire19Screen from '~/pages/homes/weight-loss/Questionnaire19Screen';
import Questionnaire20Screen from '~/pages/homes/weight-loss/Questionnaire20Screen';
import Questionnaire21Screen from '~/pages/homes/weight-loss/Questionnaire21Screen';
import Questionnaire22Screen from '~/pages/homes/weight-loss/Questionnaire22Screen';
import {RootState} from '~/redux/root-reducer';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {redirectInIframe} from '~/utils/helpers';
import {trackPageViewGA} from '~/services/google-analytics';

const WeightLoss = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const {wpAuthUser} = medicalQuestionnaire;
  const questionnaires = medicalQuestionnaire?.questionnaires;

  useEffect(() => {
    if (!wpAuthUser?.id) {
      if (wpAuthUser?.baseURL && wpAuthUser?.currentURL) {
        redirectInIframe(wpAuthUser.baseURL + '/login/?redirect_to=' + wpAuthUser?.currentURL, '_self');
      }
    }
  }, [wpAuthUser?.baseURL, wpAuthUser?.currentURL, wpAuthUser?.id]);

  if (!questionnaires?.length) return null;
  if (!wpAuthUser?.id) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case WEIGHT_LOSS_KEYS.START:
        trackPageViewGA('/weight-loss/start', 'MDQ-Weight Loss - Start');
        return <Questionnaire1Screen />;
      case WEIGHT_LOSS_KEYS.PROFILE:
        trackPageViewGA('/weight-loss/profile', 'MDQ-Weight Loss - Profile');
        return <Questionnaire2Screen />;
      case WEIGHT_LOSS_KEYS.INVALID:
        trackPageViewGA('/weight-loss/invalid', 'MDQ-Weight Loss - Invalid');
        return <Questionnaire3Screen />;
      case WEIGHT_LOSS_KEYS.IMPORTANT_INFORMATION:
        trackPageViewGA('/weight-loss/important-information', 'MDQ-Weight Loss - Important Information');
        return <Questionnaire4Screen />;
      case WEIGHT_LOSS_KEYS.ABOUT_SAXENDA:
        trackPageViewGA('/weight-loss/about-saxenda', 'MDQ-Weight Loss - About Saxenda');
        return <Questionnaire5Screen />;
      case WEIGHT_LOSS_KEYS.HOW_WEIGHT_LOSS_PROGRAM_WORKS:
        trackPageViewGA(
          '/weight-loss/how-weight-loss-program-works',
          'MDQ-Weight Loss - How Weight Loss Program Works',
        );
        return <Questionnaire6Screen />;
      case WEIGHT_LOSS_KEYS.BMI_CALCULATOR:
        trackPageViewGA('/weight-loss/bmi-calculator', 'MDQ-Weight Loss - BMI Calculator');
        return <Questionnaire7Screen />;
      case WEIGHT_LOSS_KEYS.BMI_UNDERWEIGHT:
        trackPageViewGA('/weight-loss/bmi-underweight', 'MDQ-Weight Loss - BMI Underweight');
        return <Questionnaire8Screen />;
      case WEIGHT_LOSS_KEYS.BMI_HEALTHY_BLOCK:
        trackPageViewGA('/weight-loss/bmi-healthy-block', 'MDQ-Weight Loss - BMI Healthy Block');
        return <Questionnaire9BScreen />;
      case WEIGHT_LOSS_KEYS.BMI_HEALTHY_NEXT:
        trackPageViewGA('/weight-loss/bmi-healthy-next', 'MDQ-Weight Loss - BMI Healthy Next');
        return <Questionnaire9Screen />;
      case WEIGHT_LOSS_KEYS.BMI_OVERWEIGHT:
        trackPageViewGA('/weight-loss/bmi-overweight', 'MDQ-Weight Loss - BMI Overweight');
        return <Questionnaire10Screen />;
      case WEIGHT_LOSS_KEYS.BMI_ALLERGIC:
        trackPageViewGA('/weight-loss/bmi-allergic', 'MDQ-Weight Loss - BMI Allergic');
        return <Questionnaire11Screen />;
      case WEIGHT_LOSS_KEYS.OBESITY_RELATED_CONDITIONS:
        trackPageViewGA('/weight-loss/obesity-related-conditions', 'MDQ-Weight Loss - Obesity Related Conditions');
        return <Questionnaire12Screen />;
      case WEIGHT_LOSS_KEYS.FOLLOWING_APPLY:
        trackPageViewGA('/weight-loss/following-apply', 'MDQ-Weight Loss - Following Apply');
        return <Questionnaire13Screen />;
      case WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_LIFESTYLE:
        trackPageViewGA('/weight-loss/describe-current-lifestyle', 'MDQ-Weight Loss - Describe Current Lifestyle');
        return <Questionnaire14Screen />;
      case WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_EATING_HABITS:
        trackPageViewGA(
          '/weight-loss/describe-current-eating-habits',
          'MDQ-Weight Loss - Describe Current Eating Habits',
        );
        return <Questionnaire15Screen />;
      case WEIGHT_LOSS_KEYS.TAKE_WEIGHT_LOSS_MEDICATION_BEFORE:
        trackPageViewGA(
          '/weight-loss/take-weight-loss-medication-before',
          'MDQ-Weight Loss - Take Weight Loss Medication Before',
        );
        return <Questionnaire16Screen />;
      case WEIGHT_LOSS_KEYS.DID_MEDICATION_WORK:
        trackPageViewGA('/weight-loss/did-medication-work', 'MDQ-Weight Loss - Did Medication Work');
        return <Questionnaire17Screen />;
      case WEIGHT_LOSS_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY:
        trackPageViewGA(
          '/weight-loss/other-condition-or-medical-history',
          'MDQ-Weight Loss - Other Condition Or Medical History',
        );
        return <Questionnaire18Screen />;
      case WEIGHT_LOSS_KEYS.METABOLIC_ASSESSMENT:
        trackPageViewGA('/weight-loss/metabolic-assessment', 'MDQ-Weight Loss - Metabolic Assessment');
        return <Questionnaire19Screen />;
      case WEIGHT_LOSS_KEYS.DOCTOR_ASSESSMENT:
        trackPageViewGA('/weight-loss/doctor-assessment', 'MDQ-Weight Loss - Doctor Assessment');
        return <Questionnaire20Screen />;
      case WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/weight-loss/appointment-preferences', 'MDQ-Weight Loss - Appointment Preferences');
        return <Questionnaire21Screen />;
      case WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/weight-loss/your-test-package', 'MDQ-Weight Loss - Your Test Package');
        return <Questionnaire22Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default WeightLoss;
